module.exports = __webpack_public_path__ + "static/media/arrow-alt-square-down.e059c11d.svg";